export const MiniDashboardHome = () => {
    return (
        <div></div>
    )
}